export default "__VITE_ASSET__D6C05AsQ__"